module.exports = __webpack_public_path__ + "static/media/next-course-history.5adaeee8.svg";